function p(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var V = function(t, n) {
  n || (n = {}), typeof n == "function" && (n = { cmp: n });
  var r = typeof n.cycles == "boolean" ? n.cycles : !1, e = n.cmp && /* @__PURE__ */ function(s) {
    return function(a) {
      return function(c, l) {
        var h = { key: c, value: a[c] }, i = { key: l, value: a[l] };
        return s(h, i);
      };
    };
  }(n.cmp), o = [];
  return function s(a) {
    if (a && a.toJSON && typeof a.toJSON == "function" && (a = a.toJSON()), a !== void 0) {
      if (typeof a == "number") return isFinite(a) ? "" + a : "null";
      if (typeof a != "object") return JSON.stringify(a);
      var c, l;
      if (Array.isArray(a)) {
        for (l = "[", c = 0; c < a.length; c++)
          c && (l += ","), l += s(a[c]) || "null";
        return l + "]";
      }
      if (a === null) return "null";
      if (o.indexOf(a) !== -1) {
        if (r) return JSON.stringify("__cycle__");
        throw new TypeError("Converting circular structure to JSON");
      }
      var h = o.push(a) - 1, i = Object.keys(a).sort(e && e(a));
      for (l = "", c = 0; c < i.length; c++) {
        var f = i[c], b = s(a[f]);
        b && (l && (l += ","), l += JSON.stringify(f) + ":" + b);
      }
      return o.splice(h, 1), "{" + l + "}";
    }
  }(t);
};
const F = /* @__PURE__ */ p(V), S = (t) => H(F(t)), U = (t) => {
  if (t && t.length > 0)
    try {
      return JSON.parse(y(t));
    } catch {
      return JSON.parse(decodeURIComponent(atob(decodeURIComponent(t))));
    }
}, H = (t) => btoa(encodeURIComponent(t)), y = (t) => {
  try {
    return decodeURIComponent(atob(t));
  } catch {
    return decodeURIComponent(atob(decodeURIComponent(t)));
  }
}, I = (t) => {
  const n = t instanceof URL ? t : new URL(t);
  return P(n.hash);
}, P = (t) => {
  let n = t;
  for (; n.startsWith("#"); )
    n = n.substring(1);
  const r = n.indexOf("?");
  if (r === -1)
    return [n, {}];
  const e = n.substring(0, r);
  n = n.substring(r + 1);
  const o = {};
  return n.split("&").filter((s) => s.length > 0).map((s) => {
    const a = s.indexOf("=");
    if (a === -1)
      return [s, ""];
    const c = s.substring(0, a), l = s.substring(a + 1);
    return [c, l];
  }).forEach(([s, a]) => {
    o[s] = a;
  }), Object.keys(o).forEach((s) => {
    o[s] = o[s];
  }), [e, o];
}, d = (t, n) => {
  const [r, e] = I(t);
  return e[n];
}, u = () => typeof window < "u" && typeof globalThis.location < "u", N = (t) => {
  if (u())
    return O()[1][t];
}, O = () => u() ? I(globalThis.location.href) : ["", {}], g = (t, n, r) => {
  if (!u())
    return;
  const e = globalThis.location.hash.startsWith("#") ? globalThis.location.hash.substring(1) : globalThis.location.hash, o = v(e, t, n);
  o !== e && (r != null && r.modifyHistory ? globalThis.location.hash = o : (globalThis.history.replaceState(null, typeof document < "u" ? document.title : "", `${globalThis.location.pathname}${globalThis.location.search}${o.startsWith("#") ? "" : "#"}${o}`), globalThis.dispatchEvent(new HashChangeEvent("hashchange"))));
}, v = (t, n, r) => {
  const [e, o] = P(t);
  let s = !1;
  if (o.hasOwnProperty(n) && r === null || r === void 0 ? (delete o[n], s = !0) : o[n] !== r && (o[n] = r, s = !0), !s)
    return t;
  const a = Object.keys(o);
  a.sort();
  const c = a.map((l, h) => {
    const i = o[l];
    return /^[A-Za-z0-9+/]+={0,2}$/.test(i) && i.length % 4, `${l}=${i}`;
  }).join("&");
  return !e && !c ? "" : `${e || ""}${c ? "?" + c : ""}`;
}, W = (t, n) => {
  let r = t;
  for (; r.startsWith("#"); )
    r = r.substring(1);
  const e = r.indexOf("?"), o = e === -1 ? r : r.substring(0, e), s = {};
  if (e !== -1) {
    const h = r.substring(e + 1);
    h.length > 0 && h.split("&").forEach((i) => {
      if (i.length > 0) {
        const f = i.indexOf("=");
        if (f === -1)
          s[i] = "";
        else {
          const b = i.substring(0, f), w = i.substring(f + 1);
          s[b] = w;
        }
      }
    });
  }
  let a = !1;
  for (const [h, i] of Object.entries(n))
    i == null ? s.hasOwnProperty(h) && (delete s[h], a = !0) : s[h] !== i && (s[h] = i, a = !0);
  if (!a)
    return t;
  const c = Object.keys(s);
  c.sort();
  const l = c.map((h) => {
    const i = s[h];
    return /^[A-Za-z0-9+/]+={0,2}$/.test(i) && i.length % 4, `${h}=${i}`;
  }).join("&");
  return !o && !l ? "" : `${o || ""}${l ? "?" + l : ""}`;
}, m = (t, n, r) => {
  const e = t instanceof URL ? t : new URL(t), o = v(e.hash, n, r);
  return e.hash = o, e;
}, x = (t, n) => {
  const r = t instanceof URL ? t : new URL(t);
  let e = W(r.hash, n);
  return r.hash = e, r;
}, L = (t, n, r) => {
  const e = t instanceof URL ? t : new URL(t);
  return e.hash = B(e.hash, n, r), e;
}, T = (t, n) => {
  const r = d(t, n);
  if (r && r !== "")
    return U(r);
}, _ = (t, n) => {
  const [r, e] = P(t), o = e[n];
  if (o && o !== "")
    return U(o);
}, k = (t, n, r) => {
  const e = n ? S(n) : void 0;
  g(t, e, r);
}, D = (t) => {
  if (u())
    return T(globalThis.location.href, t);
}, B = (t, n, r) => {
  const e = r ? S(r) : void 0;
  return v(t, n, e);
}, A = (t, n, r) => m(t, n, r ? r.toString() : void 0), R = (t, n) => {
  const r = d(t, n);
  return r ? parseFloat(r) : void 0;
}, J = (t, n, r) => {
  g(t, n != null ? n.toString() : void 0, r);
}, q = (t) => {
  if (u())
    return R(globalThis.location.href, t);
}, z = (t, n, r) => m(t, n, r != null ? r.toString() : void 0), j = (t, n) => {
  const r = d(t, n);
  return r ? parseInt(r) : void 0;
}, Z = (t, n, r) => {
  J(t, n, r);
}, M = (t) => {
  if (u())
    return j(globalThis.location.href, t);
}, G = (t, n, r) => m(t, n, r ? "true" : void 0), $ = (t, n) => d(t, n) === "true", K = (t, n, r) => {
  g(t, n ? "true" : void 0, r);
}, Q = (t) => {
  if (u())
    return $(globalThis.location.href, t);
}, X = (t, n, r) => m(t, n, r == null ? void 0 : H(r)), C = (t, n) => {
  const r = d(t, n);
  return r && r !== "" ? y(r) : void 0;
}, Y = (t, n, r) => {
  const e = n == null ? void 0 : H(n);
  g(t, e, r);
}, tt = (t) => {
  if (u())
    return C(globalThis.location.href, t);
}, nt = (t, n, r) => m(t, n, r == null ? void 0 : encodeURIComponent(r)), E = (t, n) => {
  const r = d(t, n);
  return r && r !== "" ? decodeURIComponent(r) : void 0;
}, rt = (t, n, r) => {
  const e = n == null ? void 0 : encodeURIComponent(n);
  g(t, e, r);
}, et = (t) => {
  if (u())
    return E(globalThis.location.href, t);
}, at = (t, n) => {
  g(t, void 0, n);
}, ot = (t, n) => m(t, n, void 0);
export {
  U as blobFromBase64String,
  S as blobToBase64String,
  W as createHashParamValuesInHashString,
  ot as deleteHashParamFromUrl,
  at as deleteHashParamFromWindow,
  N as getHashParamFromWindow,
  d as getHashParamValue,
  C as getHashParamValueBase64DecodedFromUrl,
  tt as getHashParamValueBase64DecodedFromWindow,
  $ as getHashParamValueBooleanFromUrl,
  Q as getHashParamValueBooleanFromWindow,
  R as getHashParamValueFloatFromUrl,
  q as getHashParamValueFloatFromWindow,
  j as getHashParamValueIntFromUrl,
  M as getHashParamValueIntFromWindow,
  _ as getHashParamValueJsonFromHashString,
  T as getHashParamValueJsonFromUrl,
  D as getHashParamValueJsonFromWindow,
  E as getHashParamValueUriDecodedFromUrl,
  et as getHashParamValueUriDecodedFromWindow,
  O as getHashParamsFromWindow,
  I as getUrlHashParams,
  P as getUrlHashParamsFromHashString,
  g as setHashParamInWindow,
  X as setHashParamValueBase64EncodedInUrl,
  Y as setHashParamValueBase64EncodedInWindow,
  G as setHashParamValueBooleanInUrl,
  K as setHashParamValueBooleanInWindow,
  A as setHashParamValueFloatInUrl,
  J as setHashParamValueFloatInWindow,
  v as setHashParamValueInHashString,
  m as setHashParamValueInUrl,
  z as setHashParamValueIntInUrl,
  Z as setHashParamValueIntInWindow,
  B as setHashParamValueJsonInHashString,
  L as setHashParamValueJsonInUrl,
  k as setHashParamValueJsonInWindow,
  nt as setHashParamValueUriEncodedInUrl,
  rt as setHashParamValueUriEncodedInWindow,
  x as setHashParamsInUrl,
  y as stringFromBase64String,
  H as stringToBase64String
};
//# sourceMappingURL=index.js.map
